import PaddleLogoIcon from './PaddleLogoIcon';
import { AVAILABILITY_IMAGE_TAGLINE } from '../../constants/bookingConst';

/**
 * The club's mark in a template header: logo (or the drawn paddle icon when
 * none is uploaded), then "THE" small, the club name large, and optionally
 * the tagline under it. Every size and colour comes from the template's CSS
 * through the class names, so one component serves all three designs.
 *
 * @param {object} props
 * @param {object} props.snapshot - buildAvailabilitySnapshot() output
 * @param {number} props.iconSize - px
 * @param {string} props.iconColor - colour for the drawn icon
 * @param {boolean} [props.iconFilled] - solid icon instead of outline
 * @param {boolean} [props.showTagline]
 * @param {number} [props.nameSize] - px override for the club name, so a long name can shrink to fit
 * @param {string} [props.className] - e.g. 'avb-mark-dark'
 * @returns {JSX.Element}
 */
function ClubBrandMark({ snapshot, iconSize, iconColor, iconFilled = false, showTagline = true, nameSize, className = '' }) {
  return (
    <div className={`avb-mark ${className}`.trim()}>
      <span className="avb-mark-icon" style={{ width: iconSize, height: iconSize }}>
        {snapshot.logoUrl
          ? <img src={snapshot.logoUrl} alt="" style={{ width: iconSize, height: iconSize }} />
          : <PaddleLogoIcon size={iconSize} color={iconColor} filled={iconFilled} />}
      </span>
      <span className="avb-mark-text">
        {snapshot.clubNamePrefix && <span className="avb-mark-prefix">{snapshot.clubNamePrefix}</span>}
        <span className="avb-mark-name" style={nameSize ? { fontSize: nameSize } : undefined}>{snapshot.clubNameMain}</span>
        {showTagline && <span className="avb-mark-tagline">{AVAILABILITY_IMAGE_TAGLINE}</span>}
      </span>
    </div>
  );
}

export default ClubBrandMark;
